import { z } from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { AddressFormSchema } from '../../AddressService/schemas';

const CustomerRecognitionFormSchemaWithAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  cnpj: z.string().optional(),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  recognitionGroupIds: z.number().array(),
  facialControllerIds: z.number().array(),
  isAddress: z.literal(true),
  address: AddressFormSchema,
  birthDate: z.string({ message: MANDATORY_FIELD }),
  occupation: z.string().optional(),
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  email: z.string().optional(),
  age: z.string(),
  gender: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
});

const CustomerRecognitionFormSchemaWithoutAddress = z.object({
  id: z.number().optional(),
  name: z.string().nonempty({ message: MANDATORY_FIELD }),
  cpf: z.string().nonempty({ message: MANDATORY_FIELD }),
  cnpj: z.string().optional(),
  image: z.string().optional(),
  validUntil: z.string().nullish(),
  recognitionGroupIds: z.number().array(),
  facialControllerIds: z.number().array(),
  isAddress: z.literal(false),
  address: z.null(),
  birthDate: z.string({ message: MANDATORY_FIELD }),
  occupation: z.string().optional(),
  phone: z.string().nonempty({ message: MANDATORY_FIELD }),
  email: z.string().optional(),
  age: z.string(),
  gender: z.string({ message: MANDATORY_FIELD }).nonempty({ message: MANDATORY_FIELD }),
});

export const CustomerRecognitionFormSchema = z
  .discriminatedUnion('isAddress', [
    CustomerRecognitionFormSchemaWithAddress,
    CustomerRecognitionFormSchemaWithoutAddress,
  ])
  .superRefine((data, ctx) => {
    if (
      (data.recognitionGroupIds?.length ?? 0) === 0 &&
      (data.facialControllerIds?.length ?? 0) === 0
    ) {
      ctx.addIssue({
        path: ['recognitionGroupIds'],
        code: z.ZodIssueCode.custom,
        message: 'Selecione ao menos um grupo ou/e um controlador facial.',
      });

      ctx.addIssue({
        path: ['facialControllerIds'],
        code: z.ZodIssueCode.custom,
        message: 'Selecione ao menos um grupo ou/e um controlador facial.',
      });
    }

    if (data.validUntil) {
      const validUntil = new Date(data.validUntil);
      const now = new Date();

      now.setTime(0);
      validUntil.setTime(0);

      if (validUntil.getTime() < now.getTime()) {
        ctx.addIssue({
          path: ['validUntil'],
          code: z.ZodIssueCode.custom,
          message:
            'A data de validade da face não pode ser anterior à data atual.',
        });
      }
    }
  });
